import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";
import BackButton from "../../../components/common/BackButton";
import React from "react";
import BookingForSection from "./bookingForSection";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import {
  getFamilyData,
  getPriceForFamily,
  clearPricesForFamily,
} from "../../familyInfo/familySlice";
import { IonContent, IonPage } from "@ionic/react";
import { CircularProgress } from "@mui/material";
import defaultImage from "../../../assets/images/bg_pattern.png";
import SecureImage from "../../../components/common/SecureImage";
import BookingForSectionProvider from "./bookingForSectionProvider";
import BookingDetailsSheet from "./BookingDetailsSheet";
import {
  InfoIcon,
  ListFilter,
  MapPin,
  ChevronRight,
  ChevronDown,
  ChevronUp,
} from "lucide-react";
import navigoServices from "../../../services/NavigoServices";
import { getProvidersByFilter, setStateFromPayload } from "../navigoSlice";

const ProviderCard = () => {
  const patientProfile = useSelector(
    (store) => store.login.user.patientProfile,
  );
  const dispatch = useDispatch();
  const navigoStore = useSelector((store) => store.navigo);
  const { providers } = navigoStore;
  const pickedLocation = navigoStore.ui?.pickedLocation;
  const centreFilter = navigoStore.ui?.centreFilter;
  const isManualFilter = centreFilter?.mode === "manual";
  const locationLabel = isManualFilter
    ? [centreFilter.locality, centreFilter.city, centreFilter.state]
        .filter(Boolean)
        .join(", ")
    : pickedLocation?.addressData
      ? [pickedLocation.addressData.city, pickedLocation.addressData.state]
          .filter(Boolean)
          .join(" - ")
      : "";
  const activeRadiusKm =
    centreFilter?.mode === "maps"
      ? centreFilter.radiusKm
      : pickedLocation?.radiusKm;
  const [distanceOpen, setDistanceOpen] = useState(false);
  const distanceRef = React.useRef(null);
  const [customRangeOpen, setCustomRangeOpen] = useState(false);
  const [pendingCustomKm, setPendingCustomKm] = useState(30);
  const CUSTOM_RANGE_STOPS_KM = [6, 10, 15, 30, 50, 75, 100];

  const openCustomRange = () => {
    setDistanceOpen(false);
    setPendingCustomKm(
      activeRadiusKm && ![6, 10, 15].includes(activeRadiusKm)
        ? activeRadiusKm
        : 30,
    );
    setCustomRangeOpen(true);
  };

  const applyCustomRange = () => {
    setCustomRangeOpen(false);
    applyRadius(pendingCustomKm);
  };

  useEffect(() => {
    if (!distanceOpen) return undefined;
    const handler = (e) => {
      if (distanceRef.current && !distanceRef.current.contains(e.target)) {
        setDistanceOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [distanceOpen]);
  const location = useLocation();
  const services = location?.state?.service;
  const pageType = location?.state?.pageType;
  const history = useHistory();
  const [showBooking, setShowBooking] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState();
  const familyStore = useSelector((store) => store.familyInfo);
  const {
    loadedFamily,
    loadedRelation,
    fetchingFamily,
    fetchingRelations,
    familyData,
    relations,
    pricesForFamily,
  } = familyStore;

  // useEffect(() => {
  //   if (familyData?.length && selectedProvider) {
  //     familyData.forEach((fm) => {
  //       const body = {
  //         memberPatientId: fm.memberPatientId,
  //         memberRealtion: fm.relation,
  //         patientId: fm.patientId,
  //         serviceMode: selectedProvider.service,
  //         planId: services.planId,
  //         serviceId: services.serviceId,
  //         serviceMode: services.serviceModeDetails[0].modeName,
  //       };
  //       dispatch(getPriceForFamily(body));
  //     });
  //   }
  // }, [familyData, selectedProvider]);

  const handleAvailNow = async (provider) => {
    setSelectedProvider(provider);
    dispatch(setStateFromPayload({ selectedBookingProvider: provider }));
    dispatch(clearPricesForFamily());
    const resultAction = await dispatch(getFamilyData());

    const selfBody = {
      memberPatientId: patientProfile.id,
      memberRealtion: 0,
      patientId: patientProfile.id,
      planId: services.planId,
      serviceId: services.serviceId,
      serviceMode: services.serviceModeDetails[0].modeName,
    };
    dispatch(getPriceForFamily(selfBody));

    const familyMembers = resultAction.payload.data;
    familyMembers?.forEach((fm) => {
      const sameRelationPIds = familyMembers
        .filter((member) => member.relation === fm.relation)
        .map((member) => member.memberPatientId);
      const body = {
        memberPatientId: fm.memberPatientId,
        memberRelation: fm.relation,
        patientId: fm.patientId,
        planId: services.planId,
        serviceId: services.serviceId,
        serviceMode: services.serviceModeDetails[0].modeName,
        sameRelationPIds: sameRelationPIds,
      };

      dispatch(getPriceForFamily(body));
    });
    setShowBooking(true);
  };

  const handleGotoAddress = useCallback(
    (pId, memberData, isUserSelectedFamily) => {
      history.push({
        pathname: "/address",
        state: {
          isMember: pId !== -1 ? true : false,
          memberPatientId: pId,
          memberEmail: memberData.email,
          memberData: { ...memberData },
          isPath: true,
          isNavigo: true,
          path: "/navigo",
          isUserSelectedFamily: isUserSelectedFamily
            ? isUserSelectedFamily
            : "",
        },
      });
    },
    [],
  );

  // Preload state filter options once when arriving from the map flow.
  useEffect(() => {
    if (!pickedLocation || !services?.serviceId) return;
    navigoServices
      .getLocationFilters({
        type: "state",
        state: "",
        city: "",
        locality: "",
        serviceMode: services?.serviceModeDetails?.[0]?.modeName,
        serviceId: services?.serviceId,
        planId: services?.planId,
      })
      .then((res) =>
        dispatch(
          setStateFromPayload({ locationFilterStates: res?.data?.state || [] }),
        ),
      )
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openFilters = () => {
    history.push({
      pathname: "/centre-filters",
      state: { service: services, pageType },
    });
  };

  const applyRadius = (km) => {
    setDistanceOpen(false);
    if (!pickedLocation) return;
    const body = {
      pageNum: 0,
      pageSize: 0,
      planId: services?.planId,
      serviceId: services?.serviceId,
      serviceMode: services?.serviceModeDetails?.[0]?.modeName,
      patientId: patientProfile?.id,
      memberPatientId: 0,
      languageMatch: [],
      serviceProviderIds: [],
      vendorDoctorId: 0,
      vendorCode: "",
      vendorId: "",
      providerAddressId: "",
      locationFilter: null,
      geolocationFilter: {
        latitude: pickedLocation.lat,
        longitude: pickedLocation.lng,
        radius: km * 1000,
      },
    };
    dispatch(getProvidersByFilter(body));
    dispatch(
      setStateFromPayload({
        pickedLocation: { ...pickedLocation, radiusKm: km },
        centreFilter: { mode: "maps", radiusKm: km },
      }),
    );
  };
  return (
    <IonPage>
      <IonContent>
        {" "}
        <div
          className="navigo-booking-container p-0 min-w-full bg-gray-50"
          style={
            !showBooking
              ? {
                  paddingBottom: "calc(70px + env(safe-area-inset-bottom, 0px))",
                }
              : undefined
          }
        >
          {!showBooking && (
            <div className="navigo-booking-container-back-button">
              <BackButton />
              <p>{services?.name}</p>
            </div>
          )}

          {!showBooking && pickedLocation && (
            <div
              style={{
                padding: "12px 16px 4px",
                display: "flex",
                flexDirection: "column",
                gap: 10,
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              <button
                type="button"
                onClick={openFilters}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "12px 16px",
                  border: "1px solid #C7CBD9",
                  borderRadius: 10,
                  backgroundColor: "#FFFFFF",
                  cursor: "pointer",
                  width: "100%",
                  textAlign: "left",
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                <ListFilter size={18} style={{ color: "#12194C" }} />
                <span
                  style={{
                    flex: 1,
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#12194C",
                  }}
                >
                  Filter
                </span>
                <ChevronRight
                  size={18}
                  style={{ color: "#6B7280", flexShrink: 0 }}
                />
              </button>

              <div style={{ display: "flex", gap: 10 }}>
                <button
                  type="button"
                  onClick={() => history.goBack()}
                  style={{
                    flex: 1,
                    minWidth: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "12px 14px",
                    border: "1px solid #97144D",
                    borderRadius: 10,
                    backgroundColor: "#FFFFFF",
                    cursor: "pointer",
                    fontFamily: "'Montserrat', sans-serif",
                  }}
                >
                  <MapPin
                    size={18}
                    style={{ color: "#97144D", flexShrink: 0 }}
                  />
                  <span
                    style={{
                      flex: 1,
                      minWidth: 0,
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#12194C",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "left",
                    }}
                  >
                    {locationLabel || "Selected location"}
                  </span>
                  <ChevronRight
                    size={18}
                    style={{ color: "#97144D", flexShrink: 0 }}
                  />
                </button>

                {!isManualFilter && (
                  <div
                    ref={distanceRef}
                    style={{ position: "relative", flexShrink: 0 }}
                  >
                    <button
                      type="button"
                      onClick={() => setDistanceOpen((o) => !o)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: "12px 14px",
                        border: "1px solid #C7CBD9",
                        borderRadius: 10,
                        backgroundColor: "#FFFFFF",
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#12194C",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Within {activeRadiusKm} km
                      </span>
                      {distanceOpen ? (
                        <ChevronUp
                          size={18}
                          style={{ color: "#6B7280", flexShrink: 0 }}
                        />
                      ) : (
                        <ChevronDown
                          size={18}
                          style={{ color: "#6B7280", flexShrink: 0 }}
                        />
                      )}
                    </button>

                    {distanceOpen && (
                      <div
                        style={{
                          position: "absolute",
                          top: "calc(100% + 6px)",
                          right: 0,
                          minWidth: 200,
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #E5E7EB",
                          borderRadius: 12,
                          boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                          overflow: "hidden",
                          zIndex: 20,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "12px 16px",
                            borderBottom: "1px solid #F1F5F9",
                            fontSize: 15,
                            fontWeight: 700,
                            color: "#12194C",
                          }}
                        >
                          Select range
                          <ChevronUp size={18} style={{ color: "#6B7280" }} />
                        </div>
                        {[6, 10, 15].map((km) => {
                          const active = activeRadiusKm === km;
                          return (
                            <button
                              key={km}
                              type="button"
                              onClick={() => applyRadius(km)}
                              style={{
                                display: "block",
                                width: "100%",
                                textAlign: "left",
                                padding: "12px 16px",
                                border: "none",
                                backgroundColor: active ? "#F5F3FF" : "#FFFFFF",
                                cursor: "pointer",
                                fontSize: 14,
                                fontWeight: active ? 700 : 500,
                                color: "#12194C",
                                fontFamily: "'Montserrat', sans-serif",
                              }}
                            >
                              Within {km} km
                            </button>
                          );
                        })}
                        <button
                          type="button"
                          onClick={openCustomRange}
                          style={{
                            display: "block",
                            width: "100%",
                            textAlign: "left",
                            padding: "12px 16px",
                            border: "none",
                            backgroundColor: "#FFFFFF",
                            cursor: "pointer",
                            fontSize: 14,
                            fontWeight: 500,
                            color: "#12194C",
                            fontFamily: "'Montserrat', sans-serif",
                          }}
                        >
                          Custom km
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          <div>
            {navigoStore.ui.loadingProvider ? (
              <div className="w-full h-screen flex items-center justify-center">
                <CircularProgress />
              </div>
            ) : (
              <div>
                {showBooking ? (
                  <BookingForSectionProvider
                    handleGotoAddress={handleGotoAddress}
                    providerData={selectedProvider}
                    service={services}
                    pageType={pageType}
                    onBackToList={() => setShowBooking(false)}
                  />
                ) : providers?.length > 0 ? (
                  providers.map((provider) => (
                    <div
                      className="navigo-general-card-container shadow-md rounded-lg bg-white relative"
                      key={provider.id}
                    >
                      {/* Info Icon - Top Right Corner */}
                      <div className="absolute top-2 right-2 z-10">
                        <button
                          onClick={() =>
                            history.push({
                              pathname: "/serviceDetails",
                              state: { provider },
                            })
                          }
                          className="p-0 m-0 bg-transparent border-none outline-none hover:text-gray-800"
                        >
                          <InfoIcon size={18} />
                        </button>
                      </div>

                      <div
                        className="navigo-general-card-container-top flex"
                        style={{ marginBottom: 6, alignItems: "flex-start" }}
                      >
                        <div
                          className="navigo-general-card-container-top-left"
                          style={{
                            width: 64,
                            height: 64,
                            minWidth: 64,
                            flexShrink: 0,
                            overflow: "hidden",
                            borderRadius: 12,
                          }}
                        >
                          <SecureImage
                            defaultImage={defaultImage}
                            src={provider.mobileCover}
                            classN="navigo-provider-thumb"
                          />
                        </div>

                        <div
                          className="navigo-general-card-container-top-right flex-1"
                          style={{ justifyContent: "flex-start" }}
                        >
                          <div className="flex flex-col gap-1">
                            <p className="font-bold text-xl text-gray-900">
                              {provider.name}
                            </p>{" "}
                            <p className="text-sm text-gray-600">
                              {provider?.experience}
                            </p>
                            <p className="text-sm text-gray-600">
                              {provider?.shortdescription}
                            </p>
                            <div className="flex flex-wrap">
                              {provider?.languages?.map((lang, index) => (
                                <span
                                  key={index}
                                  className="inline-flex items-center gap-1 bg-sky-100 text-800 px-2 py-1 text-xs mt-2 mr-2"
                                >
                                  {lang}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      {provider?.address?.housing && (
                        <div className="mt-2">
                          <p className="font-semibold text-sm text-gray-800 mb-0.5">
                            Address
                          </p>
                          <p
                            className="text-sm text-gray-600"
                            style={{ lineHeight: 1.4, wordBreak: "break-word" }}
                          >
                            {provider.address.housing}
                          </p>
                        </div>
                      )}

                      <div className="mt-2">
                        <p className="font-semibold text-sm text-gray-700 mb-1">
                          Available slots
                        </p>
                        <div className="flex flex-wrap gap-2">
                          {provider?.availability?.map((day, index) => (
                            <div
                              key={index}
                              className={`w-9 h-11 rounded-md flex flex-col items-center justify-center text-xs font-medium ${
                                day.IsSlotAvailable
                                  ? "bg-green-200 text-gray-800"
                                  : "bg-gray-200 text-gray-400"
                              }`}
                            >
                              <span>{day.dayStr}</span>
                              <span>{day.dayNum}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="navigo-general-card-container-bottom">
                        <div className="navigo-general-card-container-top-right-bottom">
                          <div className="navigo-general-card-container-top-right-bottom-price">
                            <span className="fw-semibold text-lg">
                              ₹
                              {
                                services?.serviceModeDetails?.[0]
                                  ?.discountedPrice
                              }
                            </span>
                            {services?.serviceModeDetails?.[0]?.maxPrice && (
                              <span
                                className="font-strikethrough text-sm"
                                style={{ marginLeft: 6 }}
                              >
                                ₹{services.serviceModeDetails[0].maxPrice}
                              </span>
                            )}
                          </div>
                        </div>

                        <button
                          className="navigo-general-card-container-bottom-book-now"
                          onClick={() => handleAvailNow(provider)}
                        >
                          Book now
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="w-full flex flex-col items-center justify-center py-10 px-4">
                    <p className="text-gray-500 text-lg font-medium">
                      No providers found
                    </p>
                    <p className="text-gray-400 text-sm mt-2 text-center">
                      No providers found for the selected location. Try a
                      different range or location.
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>

          {customRangeOpen && (
            <>
              <div
                className="navigo-sheet-backdrop"
                onClick={() => setCustomRangeOpen(false)}
                style={{
                  position: "fixed",
                  inset: 0,
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1000,
                }}
              />
              <div
                className="navigo-sheet-slide-up"
                style={{
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: "#FFFFFF",
                  padding: "24px 20px 20px",
                  borderTopLeftRadius: 20,
                  borderTopRightRadius: 20,
                  zIndex: 1001,
                  fontFamily: "'Montserrat', sans-serif",
                  boxShadow: "0 -6px 20px rgba(0,0,0,0.12)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      backgroundColor: "#FBE7ED",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MapPin size={22} style={{ color: "#97144D" }} />
                  </div>
                  <h3
                    style={{
                      margin: "18px 0 0",
                      fontSize: 18,
                      fontWeight: 700,
                      color: "#12194C",
                    }}
                  >
                    Choose custom range
                  </h3>
                  <p
                    style={{
                      margin: "10px 0 0",
                      fontSize: 13,
                      color: "#6B7280",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Higher the km, higher the chance of getting more service
                    providers
                  </p>
                </div>

                <div style={{ position: "relative", margin: "32px 8px 28px" }}>
                  <div
                    style={{
                      position: "absolute",
                      top: 10,
                      left: 8,
                      right: 8,
                      height: 2,
                      backgroundColor: "#E5E7EB",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      position: "relative",
                    }}
                  >
                    {CUSTOM_RANGE_STOPS_KM.map((km) => {
                      const isSelected = pendingCustomKm === km;
                      return (
                        <div
                          key={km}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            flex: 1,
                          }}
                        >
                          <button
                            type="button"
                            onClick={() => setPendingCustomKm(km)}
                            aria-label={`${km} km`}
                            style={{
                              width: isSelected ? 22 : 12,
                              height: isSelected ? 22 : 12,
                              borderRadius: "50%",
                              backgroundColor: "#97144D",
                              border: "none",
                              cursor: "pointer",
                              padding: 0,
                              marginTop: isSelected ? 0 : 5,
                              marginBottom: isSelected ? 0 : 5,
                              boxShadow: isSelected
                                ? "0 0 0 4px rgba(151,20,77,0.18)"
                                : "none",
                            }}
                          />
                          <span
                            style={{
                              marginTop: 12,
                              fontSize: 13,
                              fontWeight: 700,
                              color: "#12194C",
                            }}
                          >
                            {km}
                          </span>
                          <span style={{ fontSize: 11, color: "#6B7280" }}>
                            km
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <button
                  type="button"
                  onClick={applyCustomRange}
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    backgroundColor: "#97144D",
                    color: "#FFFFFF",
                    border: "none",
                    borderRadius: 8,
                    fontSize: 15,
                    fontWeight: 700,
                    cursor: "pointer",
                    fontFamily: "'Montserrat', sans-serif",
                  }}
                >
                  Continue
                </button>
              </div>
            </>
          )}
        </div>
        {!showBooking && !navigoStore.ui.loadingProvider && !customRangeOpen && (
          <BookingDetailsSheet />
        )}
      </IonContent>
    </IonPage>
  );
};

export default ProviderCard;
